<mat-button-toggle-group
  class="custom-toggle-group size-s"
  hideSingleSelectionIndicator
  [value]="tail()"
  (change)="setTail($event.value)"
>
  <mat-button-toggle value="left"><span [innerHTML]="leftTailHtml"></span></mat-button-toggle>
  <mat-button-toggle value="right"><span [innerHTML]="rightTailHtml"></span></mat-button-toggle>
</mat-button-toggle-group>

<dojo-normal-distribution-chart class="chart" [style.--chart-height.px]="chartHeight()" [params]="chartParams()" />

<div class="controls-panel">
  <div class="sliders-panel">
    <dojo-slider
      param="μ"
      [paramHtml]="muLabelHtml"
      [min]="0"
      [max]="200"
      [step]="1"
      [value]="mu()"
      [editable]="true"
      color="orange"
      variant="minimal"
      (valueChange)="onMuChange($event)"
    />
    <dojo-slider
      param="σ"
      [paramHtml]="sigmaLabelHtml"
      [min]="1"
      [max]="50"
      [step]="0.5"
      [value]="sigma()"
      [editable]="true"
      color="indigo"
      variant="minimal"
      (valueChange)="onSigmaChange($event)"
    />
    <dojo-slider
      param="p"
      [paramHtml]="pLabelHtml"
      [min]="0.01"
      [max]="0.99"
      [step]="0.01"
      [value]="p()"
      [editable]="true"
      color="neutral"
      variant="minimal"
      (valueChange)="onPChange($event)"
    />
  </div>

  <div class="divider"></div>

  <div class="formulas-panel">
    <div class="formula-row" [innerHTML]="zFormulaHtml()"></div>
    <div class="formula-row" [innerHTML]="kFormulaHtml()"></div>
  </div>
</div>
